var map = {
	"./flag-abkhazia.svg": 513,
	"./flag-afghanistan.svg": 514,
	"./flag-aland-islands.svg": 515,
	"./flag-albania.svg": 516,
	"./flag-algeria.svg": 517,
	"./flag-american-samoa.svg": 518,
	"./flag-andorra.svg": 519,
	"./flag-angola.svg": 520,
	"./flag-anguilla.svg": 521,
	"./flag-antarctica.svg": 522,
	"./flag-antigua-and-barbuda.svg": 523,
	"./flag-argentina.svg": 524,
	"./flag-armenia.svg": 525,
	"./flag-aruba.svg": 526,
	"./flag-australia.svg": 527,
	"./flag-austria.svg": 528,
	"./flag-azerbaijan.svg": 529,
	"./flag-azores-islands.svg": 530,
	"./flag-bahamas.svg": 531,
	"./flag-bahrain.svg": 532,
	"./flag-balearic-islands.svg": 533,
	"./flag-bangladesh.svg": 534,
	"./flag-barbados.svg": 535,
	"./flag-basque-country.svg": 536,
	"./flag-belarus.svg": 537,
	"./flag-belgium.svg": 538,
	"./flag-belize.svg": 539,
	"./flag-benin.svg": 540,
	"./flag-bermuda.svg": 541,
	"./flag-bhutan.svg": 542,
	"./flag-bolivia-(plurinational-state-of).svg": 543,
	"./flag-bolivia.svg": 544,
	"./flag-bonaire,-sint-eustatius-and-saba.svg": 545,
	"./flag-bonaire.svg": 546,
	"./flag-bosnia-and-herzegovina.svg": 547,
	"./flag-botswana.svg": 548,
	"./flag-bouvet-island.svg": 549,
	"./flag-brazil.svg": 550,
	"./flag-british-columbia.svg": 551,
	"./flag-british-indian-ocean-territory.svg": 552,
	"./flag-british-virgin-islands.svg": 553,
	"./flag-brunei-darussalam.svg": 554,
	"./flag-brunei.svg": 555,
	"./flag-bulgaria.svg": 556,
	"./flag-burkina-faso.svg": 557,
	"./flag-burundi.svg": 558,
	"./flag-cambodia.svg": 559,
	"./flag-cameroon.svg": 560,
	"./flag-canada.svg": 561,
	"./flag-canary-islands.svg": 562,
	"./flag-cape-verde.svg": 563,
	"./flag-cayman-islands.svg": 564,
	"./flag-central-african-republic.svg": 565,
	"./flag-ceuta.svg": 566,
	"./flag-chad.svg": 567,
	"./flag-chile.svg": 568,
	"./flag-china.svg": 569,
	"./flag-christmas-island.svg": 570,
	"./flag-cocos-(keeling)-islands.svg": 571,
	"./flag-cocos-island.svg": 572,
	"./flag-colombia.svg": 573,
	"./flag-comoros.svg": 574,
	"./flag-congo(democratic).svg": 575,
	"./flag-congo(republic).svg": 576,
	"./flag-cook-islands.svg": 577,
	"./flag-corsica.svg": 578,
	"./flag-costa-rica.svg": 579,
	"./flag-croatia.svg": 580,
	"./flag-cuba.svg": 581,
	"./flag-curacao.svg": 582,
	"./flag-curaçao.svg": 583,
	"./flag-cyprus.svg": 584,
	"./flag-czech-republic.svg": 585,
	"./flag-côte-d'ivoire.svg": 586,
	"./flag-denmark.svg": 587,
	"./flag-djibouti.svg": 588,
	"./flag-dominica.svg": 589,
	"./flag-dominican-republic.svg": 590,
	"./flag-east-timor.svg": 591,
	"./flag-ecuador.svg": 592,
	"./flag-egypt.svg": 593,
	"./flag-el-salvador.svg": 594,
	"./flag-england.svg": 595,
	"./flag-equatorial-guinea.svg": 596,
	"./flag-eritrea.svg": 597,
	"./flag-estonia.svg": 598,
	"./flag-ethiopia.svg": 599,
	"./flag-european-union.svg": 600,
	"./flag-falkland-islands-(malvinas).svg": 601,
	"./flag-falkland-islands.svg": 602,
	"./flag-faroe-islands.svg": 603,
	"./flag-fiji.svg": 604,
	"./flag-finland.svg": 605,
	"./flag-france.svg": 606,
	"./flag-french-guiana.svg": 607,
	"./flag-french-polynesia.svg": 608,
	"./flag-french-southern-territories.svg": 609,
	"./flag-gabon.svg": 610,
	"./flag-galapagos-islands.svg": 611,
	"./flag-gambia.svg": 612,
	"./flag-georgia.svg": 613,
	"./flag-germany.svg": 614,
	"./flag-ghana.svg": 615,
	"./flag-gibraltar.svg": 616,
	"./flag-greece.svg": 617,
	"./flag-greenland.svg": 618,
	"./flag-grenada.svg": 619,
	"./flag-guadeloupe.svg": 620,
	"./flag-guam.svg": 621,
	"./flag-guatemala.svg": 622,
	"./flag-guernsey.svg": 623,
	"./flag-guinea-bissau.svg": 624,
	"./flag-guinea.svg": 625,
	"./flag-guyana.svg": 626,
	"./flag-haiti.svg": 627,
	"./flag-hawaii.svg": 628,
	"./flag-honduras.svg": 629,
	"./flag-hong-kong.svg": 630,
	"./flag-hungary.svg": 631,
	"./flag-iceland.svg": 632,
	"./flag-india.svg": 633,
	"./flag-indonesia.svg": 634,
	"./flag-iran-(islamic-republic-of).svg": 635,
	"./flag-iran.svg": 636,
	"./flag-iraq.svg": 637,
	"./flag-ireland.svg": 638,
	"./flag-isle-of-man.svg": 639,
	"./flag-israel.svg": 640,
	"./flag-italy.svg": 641,
	"./flag-ivory-coast.svg": 642,
	"./flag-jamaica.svg": 643,
	"./flag-japan.svg": 644,
	"./flag-jersey.svg": 645,
	"./flag-jordan.svg": 646,
	"./flag-kazakhstan.svg": 647,
	"./flag-kenya.svg": 648,
	"./flag-kiribati.svg": 649,
	"./flag-korea-(democratic-people's-republic-of).svg": 650,
	"./flag-korea-(republic-of).svg": 651,
	"./flag-kosovo.svg": 652,
	"./flag-kuwait.svg": 653,
	"./flag-kyrgyzstan.svg": 654,
	"./flag-lao-people's-democratic-republic.svg": 655,
	"./flag-laos.svg": 656,
	"./flag-latvia.svg": 657,
	"./flag-lebanon.svg": 658,
	"./flag-lesotho.svg": 659,
	"./flag-liberia.svg": 660,
	"./flag-libya.svg": 661,
	"./flag-liechtenstein.svg": 662,
	"./flag-lithuania.svg": 663,
	"./flag-luxembourg.svg": 664,
	"./flag-macao.svg": 665,
	"./flag-macedonia.svg": 666,
	"./flag-madagascar.svg": 667,
	"./flag-madeira.svg": 668,
	"./flag-malawi.svg": 669,
	"./flag-malaysia.svg": 670,
	"./flag-maldives.svg": 671,
	"./flag-mali.svg": 672,
	"./flag-malta.svg": 673,
	"./flag-marshall-island.svg": 674,
	"./flag-marshall-islands.svg": 675,
	"./flag-martinique.svg": 676,
	"./flag-mauritania.svg": 677,
	"./flag-mauritius.svg": 678,
	"./flag-mayotte.svg": 679,
	"./flag-melilla.svg": 680,
	"./flag-mexico.svg": 681,
	"./flag-micronesia-(federated-states-of).svg": 682,
	"./flag-micronesia.svg": 683,
	"./flag-moldova.svg": 684,
	"./flag-monaco.svg": 685,
	"./flag-mongolia.svg": 686,
	"./flag-montenegro.svg": 687,
	"./flag-montserrat.svg": 688,
	"./flag-morocco.svg": 689,
	"./flag-mozambique.svg": 690,
	"./flag-myanmar.svg": 691,
	"./flag-namibia.svg": 692,
	"./flag-nauru.svg": 693,
	"./flag-nepal.svg": 694,
	"./flag-netherlands.svg": 695,
	"./flag-new-caledonia.svg": 696,
	"./flag-new-zealand.svg": 697,
	"./flag-nicaragua.svg": 698,
	"./flag-niger.svg": 699,
	"./flag-nigeria.svg": 335,
	"./flag-niue.svg": 700,
	"./flag-norfolk-island.svg": 701,
	"./flag-north-korea.svg": 702,
	"./flag-northen-cyprus.svg": 703,
	"./flag-northern-mariana-islands.svg": 704,
	"./flag-northern-marianas-islands.svg": 705,
	"./flag-norway.svg": 706,
	"./flag-oman.svg": 707,
	"./flag-orkney-islands.svg": 708,
	"./flag-ossetia.svg": 709,
	"./flag-otan.svg": 710,
	"./flag-pakistan.svg": 711,
	"./flag-palau.svg": 712,
	"./flag-palestine,-state-of.svg": 713,
	"./flag-palestine.svg": 714,
	"./flag-panama.svg": 715,
	"./flag-papua-new-guinea.svg": 716,
	"./flag-paraguay.svg": 717,
	"./flag-peru.svg": 718,
	"./flag-philippines.svg": 719,
	"./flag-pitcairn-islands.svg": 720,
	"./flag-pitcairn.svg": 721,
	"./flag-poland.svg": 722,
	"./flag-portugal.svg": 723,
	"./flag-puerto-rico.svg": 724,
	"./flag-qatar.svg": 725,
	"./flag-rapa-nui.svg": 726,
	"./flag-republic-of-kosovo.svg": 727,
	"./flag-republic-of-macedonia.svg": 728,
	"./flag-romania.svg": 729,
	"./flag-russia.svg": 730,
	"./flag-russian-federation.svg": 731,
	"./flag-rwanda.svg": 732,
	"./flag-réunion.svg": 733,
	"./flag-saba-island.svg": 734,
	"./flag-sahrawi-arab-democratic-republic.svg": 735,
	"./flag-saint-barthelemy.svg": 736,
	"./flag-saint-helena.svg": 737,
	"./flag-saint-kitts-and-nevis.svg": 738,
	"./flag-saint-lucia.svg": 739,
	"./flag-saint-martin.svg": 740,
	"./flag-saint-pierre-and-miquelon.svg": 741,
	"./flag-saint-vincent-and-the-grenadines.svg": 742,
	"./flag-samoa.svg": 743,
	"./flag-san-marino.svg": 744,
	"./flag-sao-tome-and-principe.svg": 745,
	"./flag-sardinia.svg": 746,
	"./flag-saudi-arabia.svg": 747,
	"./flag-scotland.svg": 748,
	"./flag-senegal.svg": 749,
	"./flag-serbia.svg": 750,
	"./flag-seychelles.svg": 751,
	"./flag-sicily.svg": 752,
	"./flag-sierra-leone.svg": 753,
	"./flag-singapore.svg": 754,
	"./flag-sint-eustatius.svg": 755,
	"./flag-sint-maarten-(dutch-part).svg": 756,
	"./flag-sint-maarten.svg": 757,
	"./flag-slovakia.svg": 758,
	"./flag-slovenia.svg": 759,
	"./flag-solomon-islands.svg": 760,
	"./flag-somalia.svg": 761,
	"./flag-somaliland.svg": 762,
	"./flag-south-africa.svg": 763,
	"./flag-south-georgia-and-the-south-sandwich-islands.svg": 764,
	"./flag-south-korea.svg": 765,
	"./flag-south-sudan.svg": 766,
	"./flag-spain.svg": 767,
	"./flag-sri-lanka.svg": 768,
	"./flag-sudan.svg": 769,
	"./flag-suriname.svg": 770,
	"./flag-svalbard-and-jan-mayen.svg": 771,
	"./flag-swaziland.svg": 772,
	"./flag-sweden.svg": 773,
	"./flag-switzerland.svg": 774,
	"./flag-syria.svg": 775,
	"./flag-syrian-arab-republic.svg": 776,
	"./flag-taiwan.svg": 777,
	"./flag-tajikistan.svg": 778,
	"./flag-tanzania.svg": 779,
	"./flag-thailand.svg": 780,
	"./flag-tibet.svg": 781,
	"./flag-timor-leste.svg": 782,
	"./flag-togo.svg": 783,
	"./flag-tokelau.svg": 784,
	"./flag-tonga.svg": 785,
	"./flag-transnistria.svg": 786,
	"./flag-trinidad-and-tobago.svg": 787,
	"./flag-tubalu.svg": 788,
	"./flag-tunisia.svg": 789,
	"./flag-turkey.svg": 790,
	"./flag-turkmenistan.svg": 791,
	"./flag-turks-and-caicos-islands.svg": 792,
	"./flag-turks-and-caicos.svg": 793,
	"./flag-tuvalu.svg": 794,
	"./flag-uganda.svg": 795,
	"./flag-ukraine.svg": 796,
	"./flag-united-arab-emirates.svg": 797,
	"./flag-united-kingdom.svg": 798,
	"./flag-united-nations.svg": 799,
	"./flag-united-states-minor-outlying-islands.svg": 800,
	"./flag-united-states-of-america.svg": 801,
	"./flag-uruguay.svg": 802,
	"./flag-uzbekistan.svg": 803,
	"./flag-uzbekistn.svg": 804,
	"./flag-vanuatu.svg": 805,
	"./flag-vatican-city.svg": 806,
	"./flag-venezuela-(bolivarian-republic-of).svg": 807,
	"./flag-venezuela.svg": 808,
	"./flag-viet-nam.svg": 809,
	"./flag-vietnam.svg": 810,
	"./flag-virgin-islands-(british).svg": 811,
	"./flag-virgin-islands-(u.s.).svg": 812,
	"./flag-virgin-islands.svg": 813,
	"./flag-wales.svg": 814,
	"./flag-wallis-and-futuna.svg": 815,
	"./flag-western-sahara.svg": 816,
	"./flag-yemen.svg": 817,
	"./flag-zambia.svg": 818,
	"./flag-zimbabwe.svg": 819,
	"./flag-åland-islands.svg": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;